var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons=Bookmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 17.8L5.19995 20.7V3.22498H13.05V5.09998H7.07495V17.85L12 15.725L16.925 17.85V10.975H18.8V20.7L12 17.8ZM16.925 9.09998V7.09998H14.925V5.22498H16.925V3.22498H18.8V5.22498H20.8V7.09998H18.8V9.09998H16.925Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookmark);
export default __webpack_public_path__ + "static/media/icon-bookmark.2accd3617ae0a6256c671c4276a8f98a.svg";
export { ForwardRef as ReactComponent };